import { render, staticRenderFns } from "./signBox.vue?vue&type=template&id=f6922d2c&scoped=true"
import script from "./signBox.vue?vue&type=script&lang=js"
export * from "./signBox.vue?vue&type=script&lang=js"
import style0 from "./signBox.vue?vue&type=style&index=0&id=f6922d2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6922d2c",
  null
  
)

export default component.exports